"use client";
import { Button } from "@/components/ui/button";
import { Instagram, Facebook, Twitter } from "lucide-react";

export function ShareButtons({ url, title }: { url: string; title: string }) {
  return (
    <div className="flex items-center space-x-4">
      <span className="text-sm font-medium text-gray-700">Share:</span>
      <Button
        variant="outline"
        size="sm"
        asChild
        className="border-blue-300 text-blue-600 hover:bg-blue-50"
      >
        <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`} target="_blank" rel="noopener noreferrer">
          <Facebook className="w-4 h-4 mr-1" />
          Facebook
        </a>
      </Button>
      <Button
        variant="outline"
        size="sm"
        asChild
        className="border-sky-300 text-sky-600 hover:bg-sky-50"
      >
        <a href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`} target="_blank" rel="noopener noreferrer">
          <Twitter className="w-4 h-4 mr-1" />
          Twitter
        </a>
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={() => {navigator.clipboard.writeText(url); alert('Link copied to clipboard! Share it on Instagram.')}}
        className="border-pink-300 text-pink-600 hover:bg-pink-50"
      >
        <Instagram className="w-4 h-4 mr-1" />
        Instagram
      </Button>
    </div>
  );
} 